import React, { useEffect, useState } from "react";
import { Sentence } from "./ReadingMain";
import axios from "axios";
import GrammerQues from "./GrammerQues";
import { useRecoilState } from "recoil";
import { readingProblemTypeAtom } from "../atoms/readingProblemTypeAtom";
import NounQues from "./NounQues";
import EmojiQues from "./EmojiQues";

interface Props {
  sentences: Sentence[];
  listening: boolean;
  transcript: string;
  resetTranscript: () => void;
  toggleListening: () => void;
  setCurContent: React.Dispatch<React.SetStateAction<number>>;
  curContent: number;
  setShowQues: React.Dispatch<React.SetStateAction<boolean>>;
  numberOfContents: number;
}

const ReadingQues = ({
  sentences,
  listening,
  transcript,
  resetTranscript,
  toggleListening,
  setCurContent,
  curContent,
  setShowQues,
  numberOfContents,
}: Props) => {
  const [curSentence, setCurSentence] = useState<number>(0);
  const sentence = sentences[curSentence].contents.join(" ");
  const sentenceLenght = sentences.length;
  const numberOfSentence = sentences.length;
  const [problemType, setProblemType] = useRecoilState(readingProblemTypeAtom); //0:grammer, 1:noun, 2:emoji

  return (
    <div>
      {problemType !== 2 && (
        <div className="">
          ✏️ {curSentence + 1}
          {")"} {sentence}
        </div>
      )}
      {problemType === 0 ? (
        <GrammerQues
          listening={listening}
          transcript={transcript}
          resetTranscript={resetTranscript}
          toggleListening={toggleListening}
          setCurSentence={setCurSentence}
          sentence={sentence}
          sentenceLenght={sentenceLenght}
        />
      ) : problemType === 1 ? (
        <NounQues
          listening={listening}
          transcript={transcript}
          resetTranscript={resetTranscript}
          toggleListening={toggleListening}
          setCurSentence={setCurSentence}
          sentence={sentence}
          sentenceLenght={sentenceLenght}
        />
      ) : problemType === 2 ? (
        <EmojiQues
          listening={listening}
          transcript={transcript}
          resetTranscript={resetTranscript}
          toggleListening={toggleListening}
          sentence={sentence}
          setCurSentence={setCurSentence}
          curSentence={curSentence}
          setCurContent={setCurContent}
          curContent={curContent}
          setShowQues={setShowQues}
          sentenceLenght={sentenceLenght}
          numberOfContents={numberOfContents}
        />
      ) : (
        <div>학습이 끝났습니다.</div>
      )}
    </div>
  );
};

export default ReadingQues;
